angular.module('impactx.search').controller('SearchOverviewCtrl', [
    '$scope',
    'SearchService',
    'AppConfiguration',
    '$context',
    'SearchFilter',
    'sidebarShow',
    '$rootScope',
    '$location',
    'SearchFilterStorage',
    'searchFilter',
    'ToolbarService',
    'SearchExecution',
    '$redirect',
    'TranslationService',
    'ixaProductComparison',
    SearchOverviewController
]);

function SearchOverviewController($scope, SearchService, AppConfiguration, $context, SearchFilter, sidebarShow, $rootScope,
                                  $location, SearchFilterStorage, searchFilter, ToolbarService, SearchExecution, $redirect,
                                  TranslationService, ixaProductComparison) {
    var self = this;
    var scrollPositionList = 0;
    self.initialized = false;
    self.showScrollTopButton = false;
    self.isOpen = SearchFilter.isOpen;
    self.headerIsOpen = true;
    self.SearchFilter = SearchFilter;
    self.translationService = TranslationService;
    setConfig();
    ToolbarService.showSearchFilterToggle();

    $scope.$on('$destroy', function () {
        SearchService.setUserSearchConfigParameter('expandTenderLotDefault', self.expandTenderLotDefault);
        SearchService.setUserSearchConfigParameter('expandCatalogSupplierDefault', self.expandCatalogSupplierDefault);
        ToolbarService.hideSearchFilterToggle();
    });

    self.search = function (index) {
        self.filter.productPageNumber = index;
        self.filter.productsPerPage = SearchService.getNumberOfProductRows();
        //SearchService.setFacets(SearchFilterStorage.getFacetFilter());

        return SearchService.searchProducts(self.filter.productPageNumber).then(function (searchResults) {
            if (searchResults) {
                angular.extend(self, searchResults);
            }
        })
    };

    self.searchAll = function (onInit) {
        if (!onInit && self.filter) {
            self.filter.productPageNumber = 1;
        }
        return SearchService.searchAll().then(function (searchResult) {
            angular.extend(self, searchResult);

            self.filter = SearchFilter.getFilters();
        });
    };

    self.searchTerm = function (term) {
        SearchFilter.setFilterIdentifier();
        searchFilter.searchInputGlobal = term;
        searchFilter.searchInput = term;

        SearchFilter.setFilters(SearchFilterStorage.getFreshFilter());

        searchFilter.resetDetailFilter().then(function () {
            var filterData = {};
            if ($context.hasActiveShopView.value) {
                searchFilter.listSearch.value = true;
            }

            SearchFilter.getFilters().searchInput.value = searchFilter.searchInput;
            if ($context.hasActiveShopView.value) {
                var storedSearchFilterObject = SearchFilterStorage.getVCatFilter($context.hasActiveShopView.id);
                if (storedSearchFilterObject) {
                    storedSearchFilterObject.searchInput.value = searchFilter.searchInput;
                    storedSearchFilterObject.searchInputUsed = true;
                }
                else {
                    SearchFilter.getFilters().searchInputUsed = true;
                }
                $redirect.redirectTo(null, "/vcatalog/" + $context.hasActiveShopView.id);
            }
            else {
               if ($location.path().indexOf("/search.") > -1) {
                   SearchFilter.getFilters().searchInputUsed = true;
               }
               $redirect.redirectTo(null, "/search");
            }
        });
    };

    var currentLocation = $location.path();
    var backButtonUsed = $rootScope.location !== currentLocation;
    var storedSearchFilterObject = SearchFilterStorage.getGlobalFilter();
    if (storedSearchFilterObject && backButtonUsed) {
        SearchFilter.getFilters().searchInputUsed = false;
        self.filter = storedSearchFilterObject;
        searchFilter.searchInput = self.filter.searchInput.value;
        searchFilter.searchInputGlobal = self.filter.searchInput.value;
        var guidingClassification = self.filter.guidingClassification;
        if (guidingClassification && guidingClassification.superEntries) {
            var superEntry = guidingClassification.superEntries[guidingClassification.superEntries.length - 1];
            SearchFilter.setSearchInputClassification(superEntry);
        }
        else {
            SearchFilter.setSearchInputClassification(null);
        }
        if(!self.filter.productsPerPage)
        {
            self.filter.productsPerPage = SearchService.getNumberOfProductRows();
        }
        SearchFilter.setFilters(self.filter);
        self.searchAll(true).then(function () {
            self.initialized = true;
            if(backButtonUsed) {
                SearchFilterStorage.scrollToSearchScrollPosition("overview", '#search-view');
            }
        });
    }
    else {
        self.searchAll(true).then(function () {
            SearchFilterStorage.setGlobalFilter(SearchFilter.getFilters());
            self.initialized = true;
        });
    }

    self.showScrollTop = function (showScrollTop, scrollPosition) {
        self.showScrollTopButton = showScrollTop;
        scrollPositionList = scrollPosition;
    };

    self.scrollToTop = function () {
        angular.element('#search-view').animate({
            scrollTop: scrollPositionList
        }, 200);
    };

    self.isSidebarOpen = function () {
        return sidebarShow.isOpen();
    };

    self.anyResults = function () {
        return (self.lotAvailable && self.lots && self.lots.length > 0) ||
            (self.tenderAvailable && self.tenders && self.tenders.length > 0) ||
            (self.showThemeWorldTab && self.themeWorlds && self.themeWorlds.length > 0) ||
            (self.catalogs && self.catalogs.length > 0) ||
            (self.products && self.products.length > 0) ||
            (self.showSupplierSearch && self.suppliers && self.suppliers.length > 0);
    };

    self.showNoResultsHint = function () {
        return !$context.hasActiveThemeWorldSearch || !$context.hasActiveThemeWorldSearch.value;
    };

    self.toggleHeader = function () {
        self.headerIsOpen = !self.headerIsOpen
    };

    self.updateTenders = function (pageNumber, pageSize) {
        return SearchExecution.searchTenders(SearchFilter.getFilters(), pageSize, pageNumber).then(function (result) {
            var numberOfResults = 0;
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                self.tenders = self.tenders.concat(searchResults.tenders);
                numberOfResults = searchResults.tenders.length;
            }
            return numberOfResults;
        })
    };

    self.updateLots = function (pageNumber, pageSize) {
        return SearchExecution.searchLots(SearchFilter.getFilters(), pageSize, pageNumber).then(function (result) {
            var numberOfResults = 0;
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                self.lots = self.lots.concat(searchResults.lots);
                numberOfResults = searchResults.lots.length;
            }
            return numberOfResults;
        })
    };

    self.updateCatalogs = function (pageNumber, pageSize) {
        return SearchExecution.searchCatalogs(SearchFilter.getFilters(), pageSize, pageNumber).then(function (result) {
            var numberOfResults = 0;
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                self.catalogs = self.catalogs.concat(searchResults.catalogs);
                numberOfResults = searchResults.catalogs.length;
            }
            return numberOfResults;
        })
    };

    self.updateSuppliers = function (pageNumber, pageSize) {
        return SearchExecution.searchSuppliers(SearchFilter.getFilters(), pageSize, pageNumber).then(function (result) {
            var numberOfResults = 0;
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                self.suppliers = self.suppliers.concat(searchResults.suppliers);
                numberOfResults = searchResults.suppliers.length;
            }
            return numberOfResults;
        })
    };

    function setConfig() {
        self.showThemeWorldTab = AppConfiguration.get('showThemeWorldTab') && !$context.hasActiveThemeWorld.value && !$context.hasActiveThemeWorldSearch.value;
        self.tenderAvailable = AppConfiguration.get('tenderAvailable');
        self.lotAvailable = AppConfiguration.get('lotAvailable');
        self.showSupplierSearch = AppConfiguration.get('showSupplierSearch');
        self.displayAllResultsAsList = AppConfiguration.get('displayAllResultsAsList');
        self.expandTenderLotDefault = SearchService.userSearchConfig('expandTenderLotDefault');
        self.expandCatalogSupplierDefault = SearchService.userSearchConfig('expandCatalogSupplierDefault');
    }

    $scope.$on('$routeChangeStart', function (event, newRoute, oldRoute) {
        if (newRoute.$$route.originalPath !== oldRoute.$$route.originalPath) {
            SearchFilterStorage.setSearchFilterPlaceHolder(null);
            SearchFilterStorage.setSearchScrollPosition("overview", document.getElementById('search-view').scrollTop);
        }
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                labelFunction: function (){return ixaProductComparison.getRedirectButtonLabel()},
                linkFunction: function ()
                {
                    return "productcomparison"
                },
                type: 'link',
                condition: function ()
                {
                    return ixaProductComparison.getProductComparisonCount() > 1
                }
            },
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
    defineButtons();
}